var _circle, _mask, _path, _circle2, _circle3, _circle4, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSurvey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 30,
    fill: "url(#paint0_linear_410_303)"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_410_303",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30 45C38.2843 45 45 38.2843 45 30C45 21.7157 38.2843 15 30 15C21.7157 15 15 21.7157 15 30C15 33.1641 15.9797 36.0994 17.6523 38.5191L15.9645 44.818L22.5874 43.0434C24.7738 44.2887 27.3038 45 30 45Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6523 38.5191L19.5841 39.0368L19.8236 38.143L19.2975 37.3819L17.6523 38.5191ZM15.9645 44.818L14.0327 44.3004L13.1361 47.6464L16.4821 46.7499L15.9645 44.818ZM22.5874 43.0434L23.5772 41.3055L22.8633 40.8989L22.0697 41.1116L22.5874 43.0434ZM43 30C43 37.1797 37.1797 43 30 43V47C39.3888 47 47 39.3888 47 30H43ZM30 17C37.1797 17 43 22.8203 43 30H47C47 20.6112 39.3888 13 30 13V17ZM17 30C17 22.8203 22.8203 17 30 17V13C20.6112 13 13 20.6112 13 30H17ZM19.2975 37.3819C17.8485 35.2857 17 32.7449 17 30H13C13 33.5833 14.1109 36.9132 16.0071 39.6563L19.2975 37.3819ZM17.8964 45.3357L19.5841 39.0368L15.7204 38.0015L14.0327 44.3004L17.8964 45.3357ZM22.0697 41.1116L15.4469 42.8862L16.4821 46.7499L23.105 44.9753L22.0697 41.1116ZM30 43C27.66 43 25.47 42.3835 23.5772 41.3055L21.5976 44.7813C24.0777 46.1938 26.9477 47 30 47V43Z",
    fill: "white",
    mask: "url(#path-2-inside-1_410_303)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 34.5,
    cy: 33.5,
    r: 1.5,
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_410_303",
    x1: 2.79397e-7,
    y1: 30,
    x2: 60,
    y2: 30,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8CD840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#55A368"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurvey);
export default __webpack_public_path__ + "static/media/survey.0a1a0c909ac5b6e63a57a23d1e805da3.svg";
export { ForwardRef as ReactComponent };